/** Match backend User.is_platform_admin() and main CRM isAdmin() checks. */
export function isPlatformAdmin(user?: Record<string, unknown> | null): boolean {
  try {
    if (user) {
      const role = String(user.role || '').toLowerCase();
      const tenant = String(user.tenant || '').toLowerCase();
      const businessArea = String(user.business_area || '').toLowerCase();
      if (role.includes('admin') || tenant === 'admin' || businessArea === 'admin') {
        return true;
      }
    }
    const raw = localStorage.getItem('user');
    if (raw) {
      const u = JSON.parse(raw);
      const role = String(u?.role || '').toLowerCase();
      const tenant = String(u?.tenant || '').toLowerCase();
      const businessArea = String(u?.business_area || '').toLowerCase();
      if (role.includes('admin') || tenant === 'admin' || businessArea === 'admin') {
        return true;
      }
    }
    const cognitoRaw = localStorage.getItem('cognito_user');
    if (cognitoRaw) {
      const u = JSON.parse(cognitoRaw);
      const role = String(u?.role || '').toLowerCase();
      const tenant = String(u?.tenant || '').toLowerCase();
      if (role.includes('admin') || tenant === 'admin') return true;
    }
    return (localStorage.getItem('user_tenant') || '').toLowerCase() === 'admin';
  } catch {
    return false;
  }
}
